export default __webpack_public_path__ + "static/martin-08831d3c1256f7958c639ec1c053cf66.jpg";